// extracted by mini-css-extract-plugin
module.exports = {"recipients":"style_recipients__3Tz9O","to":"style_to__3Gtm8"};